import ODropDownMenu from '../../../UI/DropDownMenu/ODropDownMenu';

const MachineOrdersOptions = ({
  children,
  getEditData,
  handleOpenDeleteDialog,
  handlePosaljiZahtev,
  poslato,
}) => {
  const options = [
    {
      title: 'Izmeni',
      subtitle: 'Izmenite podatke',
      path: 'profil',
      id: 1,
      icon: 'fas fa-pen',
      color: '#2f3a3f',
      onClick: () => getEditData(),
      disabled: poslato,
    },
    {
      title: 'Obriši',
      subtitle: 'Obrišite izabranu',
      path: 'login',
      id: 2,
      icon: 'fas fa-trash',
      color: '#ff5552',
      onClick: () => handleOpenDeleteDialog(),
      disabled: poslato,
    },
    {
      title: 'Pošalji',
      subtitle: 'Pošaljite zahtev',
      path: 'login',
      id: 3,
      icon: 'fas fa-paper-plane',
      color: '#2f3a3f',
      onClick: () => handlePosaljiZahtev(),
      disabled: poslato,
    },
  ];

  return (
    <ODropDownMenu align="end" position="anchor" options={options}>
      {children}
    </ODropDownMenu>
  );
};

export default MachineOrdersOptions;
